import { RootState } from '../../store/root-state';
import {
  ActionTakenLabelConfig,
  ActionTakenLabelOverrides,
  DisabledActionTakenTypes,
  EMPTY_ACTION_TAKEN_LABEL_CONFIG,
} from '../../scripts/action-taken-labels';

/**
 * The action configuration for the currently-loaded project's subscriber.
 *
 * Returns empty config when no project is loaded or it has not arrived yet, so every consumer
 * falls back to built-in wording and the full option set rather than rendering nothing.
 */
export const getActionTakenLabelConfig = (state: RootState): ActionTakenLabelConfig =>
  state.actionTakenLabels.bySubscriberId[state.project.project?.subscriberId ?? ''] ??
  EMPTY_ACTION_TAKEN_LABEL_CONFIG;

/** Custom display labels only — what the display helpers take. */
export const getActionTakenLabelOverrides = (state: RootState): ActionTakenLabelOverrides =>
  getActionTakenLabelConfig(state).labels;

/** Actions the subscriber has switched off — used to filter reviewer dropdowns. */
export const getDisabledActionTakenTypes = (state: RootState): DisabledActionTakenTypes =>
  getActionTakenLabelConfig(state).disabled;

/** For views that render documents from more than one subscriber. */
export const getActionTakenLabelOverridesForSubscriber = (subscriberId?: string | null) => (
  state: RootState,
): ActionTakenLabelOverrides =>
  (state.actionTakenLabels.bySubscriberId[subscriberId ?? ''] ?? EMPTY_ACTION_TAKEN_LABEL_CONFIG)
    .labels;
